import { gql } from '@apollo/client'

export const GET_TERRITORY_NICHE_CONTEXTS = gql`
  query getTerritoryNicheContexts($filters: NicheContextFiltersInput!, $pagination: NicheContextPaginationInputs) {
    listTerritoryNicheContextsPaginated(filters: $filters, pagination: $pagination) {
      totalCount
      cursor
      data {
        context
        id
        isGlobal
        createdAt
      }
    }
  }
`
export const DELETE_TERRITORY_NICHE_CONTEXT = gql`
  mutation deleteTerritoryNicheContext($input: DeleteNicheContextInput!) {
    deleteTerritoryNicheContext(input: $input) {
      success
    }
  }
`

export const CREATE_TERRITORY_NICHE_CONTEXT = gql`
  mutation createTerritoryNicheContext($input: CreateNicheContextInput!) {
    createTerritoryNicheContext(input: $input) {
      data {
        context
        createdAt
        id
      }
    }
  }
`

export const CREATE_NICHE_CONTEXT_HASH = gql`
  mutation createNicheContextHash($input: CreateNicheContextHashInput!) {
    createNicheContextHash(input: $input) {
      hash
    }
  }
`
export const GROUP_NICHES = gql`
  mutation groupNiches($input: MergeNichesInput!) {
    createMergedNiche(input: $input) {
      newNiche {
        name
        territoryId
      }
    }
  }
`

export const RENAME_NICHES = gql`
  mutation RenameNiches($input: UpdateNicheNameInput!) {
    updateNicheName(input: $input) {
      success
      results {
        success
        territory {
          territoryId
        }
      }
    }
  }
`

export const GET_TERRITORY_MAIN_NICHES = gql`
  query GetTerritoryMainNiches(
    $territoryId: ID!
    $timeRange: TimeRange
    $providers: [Providers!]
    $territoryContentFilters: TerritoryContentFilters
  ) {
    getTerritory(territoryId: $territoryId) {
      territoryId
      name

      mainNiches {
        niches {
          territoryId
          name
          promotionsV2 {
            source {
              territoryId
            }
            target {
              territoryId
              name
            }
          }
          territoryPerformance {
            metrics(timeRange: $timeRange, providers: $providers, territoryContentFilters: $territoryContentFilters) {
              totalEngagement
            }
          }
        }
        context {
          id
          context
        }
      }
    }
  }
`
